import React, {Component}  from "react";
import {SlideDown} from 'react-slidedown'
import uuidv4 from 'uuid/v4';
import AddCourseModal from '../Common/AddCourseModal';
import {NotificationManager} from 'react-notifications';
import {Link} from 'react-router-dom';

/*
const messengerControls = [
    {id: 'messenger_noti_0', text: 'Show students if the messages were seen'},
    {id: 'messenger_noti_1', text: 'Show instructors if student saw messages'},
    {id: 'messenger_noti_2', text: 'Show students when instructor is typing messages'},
    {id: 'messenger_noti_3', text: 'Show students when instructors are online/offline'},
    {id: 'messenger_noti_4', text: 'Show instructors when students are online/offline'},
    {id: 'messenger_noti_5', text: 'During off-course season, remind student to expect response in --- days'},
    {id: 'messenger_noti_6', text: 'Lock messaging thread to specific courses being taken'},
    {id: 'messenger_noti_7', text: 'Limit student messaging to --- messages per day'},
    {id: 'messenger_noti_8', text: 'Allow file uploads'},
    {id: 'messenger_noti_9', text: 'Allow audio recordings to be sent'},
    {id: 'messenger_noti_10', text: 'Allow instructors to set reminders via messenger threads'},
    {id: 'messenger_noti_11', text: 'Allow students to set personal reminders in the messenger threads'},
    {id: 'messenger_noti_12', text: 'Change thread colour to ---- during in-course times'},
    {id: 'messenger_noti_13', text: 'Allow instructors to change thread names'},
    {id: 'messenger_noti_14', text: 'Allow students to bookmark messages'},
    {id: 'messenger_noti_15', text: 'Allow instructors to tag on messages'},
    {id: 'messenger_noti_16', text: 'Allow instructors to post a schedule'},
    {id: 'messenger_noti_17', text: 'Send same message to many students'},
    {id: 'messenger_noti_18', text: 'Allow instructors to delete messages'},
    {id: 'messenger_noti_19', text: 'Allow instructors to delete shared files'},
    {id: 'messenger_noti_20', text: 'Add emoticons'}
];
*/

/*
* Component is not finished
* */
class SettingsAdmin extends Component {

    messengerControls = [
        {id: 'messenger_noti_0', text: 'Show students if the messages were seen', key: 'showSeen'},
        {id: 'messenger_noti_1', text: 'Show instructors if student saw messages', key: 'instructorShowSeen'},
        {id: 'messenger_noti_2', text: 'Show students when instructor is typing messages', key: 'whenInstructorTyping'},
        {id: 'messenger_noti_3', text: 'Show students when instructors are online/offline', key: 'whenInstructorOnline'},
        {id: 'messenger_noti_4', text: 'Show instructors when students are online/offline', key: 'whenStudentOnline'},
        {id: 'messenger_noti_5', text: 'During off-course season, remind student to expect response in --- days', key: 'remindExpectResponse'},
        {id: 'messenger_noti_6', text: 'Lock messaging thread to specific courses being taken', key: 'lockMessages'},
        {id: 'messenger_noti_7', text: 'Limit student messaging to --- messages per day', key: 'limitMessages'},
        {id: 'messenger_noti_8', text: 'Allow file uploads', key: 'allowFiles'},
        {id: 'messenger_noti_9', text: 'Allow audio recordings to be sent', key: 'allowAudio'},
        {id: 'messenger_noti_10', text: 'Allow instructors to set reminders via messenger threads', key: 'allowSetReminders'},
        {id: 'messenger_noti_11', text: 'Allow students to set personal reminders in the messenger threads', key: 'allowStudentSetReminders'},
        {id: 'messenger_noti_12', text: 'Change thread colour to ---- during in-course times', key: 'changeThreadColor'},
        {id: 'messenger_noti_13', text: 'Allow instructors to change thread names', key: 'changeThreadName'},
        {id: 'messenger_noti_14', text: 'Allow students to bookmark messages', key: 'bookmarkMessages'},
        {id: 'messenger_noti_15', text: 'Allow instructors to tag on messages', key: 'tagMessages'},
        {id: 'messenger_noti_16', text: 'Allow instructors to post a schedule', key: 'postSchedule'},
        {id: 'messenger_noti_17', text: 'Send same message to many students', key: 'massSend'},
        {id: 'messenger_noti_18', text: 'Allow instructors to delete messages', key: 'deleteFiles'},
        {id: 'messenger_noti_19', text: 'Allow instructors to delete shared files', key: 'deleteSharedFiles'},
        {id: 'messenger_noti_20', text: 'Add emoticons', key: 'emoticons'}
    ];

    notifications = {
        students: {
            items: [
                {
                    id: uuidv4(),
                    name: 'Remind students of test date every',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindTestDate',
                    selected: 'Custom'
                },
                {
                    id: uuidv4(),
                    name: 'Remind students to finish task every',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindTasks',
                    selected: 1
                },
                {
                    id: uuidv4(),
                    name: 'Remind students that they need to speed up or they are behind every',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindSpeed',
                    selected: 0
                },
                {
                    id: uuidv4(),
                    name: 'Remind students to compete every',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindCompete',
                    selected: 0
                },
                {
                    id: uuidv4(),
                    name: 'Remind students to sign up for in-class course every',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindInClass',
                    selected: 0
                },
                {
                    id: uuidv4(),
                    name: 'Remind students to sign up for a test date every',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindTestDateRegister',
                    selected: 0
                },
                {
                    id: uuidv4(),
                    name: 'Remind students that they will finish the course at the pace they are going every',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindPace',
                    selected: 0
                },
                {
                    id: uuidv4(),
                    name: 'Remind students that their predicted score is _ every',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindPredictedScore',
                    selected: 0
                },
                {
                    id: uuidv4(),
                    name: 'Remind students when deadline is missed every',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindDeadlineMissed',
                    selected: 0
                },
                {
                    id: uuidv4(),
                    name: 'Remind students of an upcoming event every',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindUpcomingEvent',
                    selected: 0
                },
                {
                    id: uuidv4(),
                    name: 'Remind students that they need to increase the amount of time they are putting in when chapter finished per day is',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindWorkHarder',
                    selected: 0
                },
                {
                    id: uuidv4(),
                    name: 'Remind students that their are doing better every',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindDoingBetter',
                    selected: 0
                },
                {
                    id: uuidv4(),
                    name: 'Remind students when a deadline is due',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindDeadlingDue',
                    selected: 0
                },
                {
                    id: uuidv4(),
                    name: 'Remind students to focus on studying when messages to friends hit messages',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindFocus',
                    selected: 0
                }
            ]
        },
        instructors: {
            items: [
                {
                    id: uuidv4(),
                    name: 'Remind instructors of students\' test date',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindFocus',
                    selected: 0
                },
                {
                    id: uuidv4(),
                    name: 'Remind instructor to respond to students\' messages',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindRespondToStudents',
                    selected: 0
                },
                {
                    id: uuidv4(),
                    name: 'During course times, remind instructor to respond to students\' messages every',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindRespondDuringCourse',
                    selected: 0
                },
                {
                    id: uuidv4(),
                    name: 'Remind instructors to log-in',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindLogin',
                    selected: 0
                },
                {
                    id: uuidv4(),
                    name: 'Remind instructors to attend to students every',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindAttentStudent',
                    selected: 0
                },
                {
                    id: uuidv4(),
                    name: 'Remind instructors to respond to discussions every',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindDiscussions',
                    selected: 0
                },
                {
                    id: uuidv4(),
                    name: 'Remind instructor that a new student has started the course',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindNewStudent',
                    selected: 0
                },
                {
                    id: uuidv4(),
                    name: 'Remind instructor when course results are released',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindResults',
                    selected: 0
                },
                {
                    id: uuidv4(),
                    name: 'Remind instructor when student takes a practice test',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindPracticeTest',
                    selected: 0
                },
                {
                    id: uuidv4(),
                    name: 'Remind instructor when students finish a subject',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindStudentFinishedSubject',
                    selected: 0
                },
                {
                    id: uuidv4(),
                    name: 'Remind instructor when students are scoring below on a lecture concepts',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindLowScore',
                    selected: 0
                },
                {
                    id: uuidv4(),
                    name: 'Alert Admin when an instructor does not respond to a student messages by the red deadline',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'alertNoResponse',
                    selected: 0
                },
                {
                    id: uuidv4(),
                    name: 'Remind instructor when student won\'t meet their deadline',
                    options: ['Select','Everyday','Every Month','Custom'],
                    value: { 
    text: '',
    customValue: '',
    customRange: '',
},
                    key: 'remindStudentNotMeetingDeadling',
                    selected: 0
                }
            ]
        }
    };


    state = {
        reminder: false,
        newTabModelIsOpen: false,
        modal: false,
        textInputModal: '',
        customId: '',
        activeCourse: null,
        editChapterModal: false,
        customValue: '',
        customRange: '',
        customSetting: {},
    };

    updateCourse = () => {
        this.props.updateCourse(this.state.activeCourse, this.props.user.userId, this.props.user.id);
    }

    //Renders
    renderHeaderSettings = () => (
        <div className="bg-light lter b-b wrapper-md">
            <div className="row">
                <div className="col-sm12 col-xs-12">
                    <h1 className="m-n font-thin h3 text-black">
                        Settings
                    </h1>
                    <small className="text-muted">
                        Notifications & Messengars
                    </small>
                </div>
            </div>
        </div>
    );

    renderNavTabs = () => (
        <ul className="nav nav-tabs bg-white">
            {this.renderNavItem('', 'course-admin', 'Courses', 'All Courses')}
            {this.renderNavItem('', 'strategy', 'Strategy', 'Setup Strategy')}
            {this.renderNavItem('', 'people', 'People', 'Access Manager')}
            {this.renderNavItem('active', 'settings-admin', 'Settings', 'Updates')}
        </ul>
    );

    renderNavigationTabs = () => (
        <ul className="nav nav-tabs">
            <div class="pull-right">
                <button className="btn btn-base" onClick={this.updateCourse}>Save Changes</button> &nbsp;
            </div>

            {this.renderTabNew()}
            {/*{this.renderTab('active', '#mcat_tab', 'MCAT')}*/}
            {/*{this.renderTab('', '#lsat_tab', 'LSAT')}*/}
            {/*{this.renderTab('', '#gmat_tab', 'GMAT')}*/}
            {/*{*/}
            {/*this.state.newTabName !== '' &&*/}
            {/*this.renderTab('', '#gfet_tab', `${this.state.newTabName}`)*/}
            {/*}*/}
            {/*/////////////////////*/}
            <div>
                <a className="btn btn-orange btn-rounded"
                   onClick={this.handleNewTabOpenState}
                >
                    {this.props.courses.length === 0 &&
                    "Add Course "}
                    <i className="zmdi zmdi-plus-circle"/>

                </a>
            </div>
        </ul>
    );

    renderTabNew = () => {
        return (
            this.props.courses.map((item, index) => {

                if(this.state.activeCourse === null && index === 0){
                    this.setState({activeCourse: item});
                }
                if(item){
                    return (
                        <li
                            key={index}
                            className={this.state.activeCourse != null && this.state.activeCourse.id === item.id ? 'active' : ''}
                        >
                            <a
                                onClick={(e) => {
                                    this.setState({activeCourse: item});
                                }}
                                data-toggle="tab"
                            >
                                {item.name}
                                <span className={"zmdi zmdi-close"} onClick={(e) => {
                                    e.preventDefault();
                                    this.deleteCourseConfirmation(item);
                                }} />
                            </a>
                        </li>
                    )
                }else{
                    return null;
                }
            })
        )
    };

    renderNavItem = (className, link, title, name) => (
        <li className={className}>
            <Link to={link}>
                {title}
                <span>
                    {name}
                </span>
            </Link>
        </li>
    );

    renderReminderSelect = (notifications, name) => (
        notifications.items.map((item, index) => (
            <div
                key={name+'_'+index}
                className="control-row"
                id={`notification_${name}0${index}`}
            >
                <div className="row">
                    <div className="col-sm-6">
                        <p>
                            {item.name}
                        </p>
                    </div>
                    <div className="col-sm-2">
                        <select
                            className="form-control"
                            value={(this.state.activeCourse) ?
                                (this.state.activeCourse.settings[name][item.key]) ?
                                this.state.activeCourse.settings[name][item.key]['text'] || ''
                                    : ''

                                : ''}
                            onChange={(e) => {
                                let {activeCourse, modal, customSetting} = this.state;

                                activeCourse.settings[name][item.key] = {
                                    text:  e.target.value,
                                    customValue: '',
                                    customRange: ''
                                };
                                if(e.target.value === "Custom"){
                                    modal = true;
                                    customSetting = this.state.activeCourse.settings[name][item.key];
                                }
                                this.setState({activeCourse, modal, customSetting});
                            }}
                        >
                            {this.renderSelects(item.options)}
                        </select>
                    </div>
                    <div className="col-sm-4">
                        {this.state.activeCourse && this.state.activeCourse.settings[name][item.key] &&
                        <div
                            className="custom_value"
                        >
                            {this.state.activeCourse.settings[name][item.key]['text'] === "Custom" &&
                                <div>
                                    <span>
                                        Every&nbsp;
                                        {this.state.activeCourse.settings[name][item.key]['customValue']}&nbsp;
                                        {this.state.activeCourse.settings[name][item.key]['customRange']}
                                        {(this.state.activeCourse.settings[name][item.key]['customValue'] > 1) ? 's' : ''}
                                        </span>
                                    <button className="btn btn-transparent"
                                        onClick={(e) => {
                                            let {modal, customSetting} = this.state;

                                            modal = true;
                                            customSetting = this.state.activeCourse.settings[name][item.key];

                                            this.setState({modal, customSetting});

                                        }}
                                    ><i className="zmdi zmdi-edit" /></button>
                                </div>
                            }
                        </div>
                        }
                    </div>
                </div>
            </div>
        ))
    );

    renderSelects = (options) => (
        options.map((option, index) =>  (
            <option
                key={index}
                value={option}
            >
                {option}
            </option>
        ))
    );

    renderNavPlusButton = (className, link, icon) => (
        <li className={className}>
            <a
                href={link}
                style={{paddingRight: "10px"}}
            >
                <div className="font-24 text-orange">
                    <i className={"zmdi zmdi-"+icon}/>
                </div>
            </a>
        </li>
    );

    handleNewTabOpenState = () => {
        this.setState({
            newTabModelIsOpen: !this.state.newTabModelIsOpen,
        })
    };

    renderMessengerControls = (controls) => (
        controls.map((item) => (
            <div
                key={item.id}
                className="control-row"
            >
                <div className="row">
                    <div className="col-sm-6">
                        <p>{item.text}</p>
                    </div>
                    <div className="col-sm-6">
                        <input type='checkbox' className='ios8-switch'
                               checked={(this.state.activeCourse) ? this.state.activeCourse.messageSettings[item.key] || '' : ''}
                               onChange={(e) => {
                                   let {activeCourse} = this.state;

                                   let v = "on";
                                   if(activeCourse.messageSettings[item.key]){
                                       if(activeCourse.messageSettings[item.key] === "on"){
                                           v = "";
                                       }
                                   }
                                   activeCourse.messageSettings[item.key] = v;
                                   this.setState({activeCourse});
                               }}

                               id={item.id} />
                        <label htmlFor={item.id}/>
                    </div>
                </div>
            </div>
        ))
    );

    //Actions
    checkIfCustomValue = (e, id) => {
        if(e.target.value === 'Custom') {
            this.setState({modal: true, customId: id});
        }
    };

    handleCloseModal = () => {
        this.setState({modal: false})
    };

    handleSubmitChanges = () => {
        this.handleCloseModal();
    };

    addNewCourse = (name, slug) => {
        this.props.addNewCourse({name: name, slug: slug, owner: this.props.user.userId, published: false, officialTest: {
            name: "",
            minScore: "",
            maxScore: "",
            sections: [
            {
                name: "",
                minScore: "",
                maxScore: ""
            }
            ]
        }}, this.props.user.id);
                this.setState({
                    newTabName: name,
                });


    };

    render() {
        return (            
            <div className="content-wrapper" id="content-container">
                {this.renderHeaderSettings()}
                <section className="content no-padding">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="nav-tabs-custom no-bg">
                                {this.props.courses.length > 0 &&
                                    this.renderNavTabs()}

                                <div className="tab-content no-bg no-padding">
                                    <div
                                        className="tab-pane active"
                                        id="tab_3"
                                    >
                                        <div className="nav-tabs-custom no-bg inner-tabs">
                                            {this.renderNavigationTabs()}
                                        </div>
                                    </div>
                                </div>

                                {this.props.courses.length > 0 ?
                                <div className="tab-content no-bg no-padding">
                                    <div
                                        className="tab-pane active"
                                        id="tab_2"
                                    >
                                        {this.state.activeCourse &&
                                        <div className="row">
                                            <div className="col-md-3">
                                            <select className="form-control" value={this.state.activeCourse.publish}
                                                onChange={(e) => {
                                                    let {activeCourse} = this.state;
                                                    if(e.target.value === "true" && !activeCourse.testId){
                                                        NotificationManager.error("You must set a diagnostic test for this course before publishing.  Please do this on the Strategy tab.");
                                                    }else {
                                                        activeCourse.publish = e.target.value;
                                                        this.setState({activeCourse});
                                                    }
                                                }
                                                }
                                            >
                                                <option value="false">Unpublished</option>
                                                <option value="true">Published</option>
                                            </select>
                                            </div>
                                        </div>
                                        }
                                        <div className="nav-tabs-custom no-bg inner-tabs">
                                            <ul className="nav nav-tabs">
                                                <li className="active">
                                                    <a
                                                        href="#NotificationsTab"
                                                        data-toggle="tab"
                                                    >
                                                        Notifications
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        href="#MessengersTab"
                                                        data-toggle="tab"
                                                    >
                                                        Messengers
                                                    </a>
                                                </li>
                                            </ul>
                                            <div className="tab-content no-bg no-padding">
                                                <div
                                                    className="tab-pane active"
                                                    id="NotificationsTab"
                                                >
                                                    <div className="panel customPanel flat">
                                                        <div className="panel-heading border-bottom bg-info">
                                                            <h3 className="panel-title text-uppercase font-400">
                                                                <span className="font-16">
                                                                    Notifications Control
                                                                </span>
                                                            </h3>
                                                        </div>
                                                        <div className="panel-body no-padding">
                                                            <div className="sm-top-bottom20">
                                                                <div className="row">
                                                                    <div className="col-sm-4 col-sm-offset-4">
                                                                        <div
                                                                            className="btn-group-justified btn-inner-tabs-controls"
                                                                            data-toggle="buttons"
                                                                            onClick={()=>this.setState({reminder: !this.state.reminder})}
                                                                        >
                                                                            <label className="btn btn-default active">
                                                                                <input
                                                                                    type="radio"
                                                                                    name="options"
                                                                                    id="option1"
                                                                                    value="student"
                                                                                    autoComplete="off"
                                                                                    defaultChecked
                                                                                />
                                                                                Students
                                                                            </label>
                                                                            <label className="btn btn-default">
                                                                                <input
                                                                                    type="radio"
                                                                                    name="options"
                                                                                    id="option2"
                                                                                    value="instructor"
                                                                                    autoComplete="off"
                                                                                />
                                                                                Instructors
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="notification_setting notification_student">
                                                                <SlideDown className={'my-dropdown-slidedown'}>
                                                                    {
                                                                        !this.state.reminder &&
                                                                        this.renderReminderSelect(this.notifications.students, 'student')
                                                                    }
                                                                </SlideDown>
                                                            </div>
                                                            <div
                                                                className="notification_setting notification_instructor"
                                                            >
                                                                <SlideDown className={'my-dropdown-slidedown'}>
                                                                    {
                                                                        this.state.reminder &&
                                                                        this.renderReminderSelect(this.notifications.instructors, 'instructor')
                                                                    }
                                                                </SlideDown>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="tab-pane" id="MessengersTab">
                                                    <div className="panel customPanel">
                                                        <div className="panel-heading border-bottom bg-info">
                                                            <h3 className="panel-title text-uppercase font-400">
                                                                <span className="font-16">
                                                                    Messenger Controls
                                                                </span>
                                                            </h3>
                                                        </div>
                                                        <div className="panel-body no-padding">
                                                            {this.renderMessengerControls(this.messengerControls)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                    : <h4>Add a course to get started</h4> }
                            </div>
                        </div>
                    </div>
                </section>
                {
                    this.state.newTabModelIsOpen &&
                    <AddCourseModal
                        onCloseModal={this.handleNewTabOpenState}
                        addNewCourse={this.addNewCourse}
                        user={this.props.user}
                    />
                }
                <div
                    className={"modal fade "+ (this.state.modal && "in")}
                    id="SetCustomVal"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="myModalLabel"
                    style={{display: this.state.modal ? "block": "none"}}
                >
                    <div
                        className="modal-dialog"
                        role="document"
                    >
                        <div className="modal-content">
                            <div className="modal-header">
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => this.handleCloseModal()}
                                >
                                    <span aria-hidden="true">
                                        &times;
                                    </span>
                                </button>
                                <h4
                                    className="modal-title"
                                    id="myModalLabel"
                                >
                                    Set Custom Value
                                </h4>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <div className="col-sm-3">
                                    <label style={{marginTop: '5px'}}>Every</label>
                                    </div>
                                    <div className="col-sm-5">

                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Custom Value"
                                        id="CustomValueInput"
                                        value={this.state.customSetting['customValue']}
                                        onChange={(e) => {
                                            let {customSetting} = this.state;
                                            customSetting['customValue'] = e.target.value;
                                            this.setState({customSetting})}}
                                    />
                                    </div>
                                    <div className="col-sm-4">
                                        <select
                                            className="form-control"
                                            value={this.state.customSetting['customRange']}
                                            onChange={(e) => {
                                                let {customSetting} = this.state;
                                                customSetting['customRange'] = e.target.value;
                                                this.setState({customSetting})
                                                }}
                                        >
                                            <option value="">Select Time Range</option>
                                            <option value="hour">Hour(s)</option>
                                            <option value="day">Day(s)</option>
                                            <option value="week">Week(s)</option>
                                            <option value="month">Month(s)</option>
                                        </select>
                                    </div>
                                </div>

                                <input
                                    type="hidden"
                                    id="SetCustomValToField"
                                />
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    data-dismiss="modal"
                                    onClick={() => this.handleCloseModal()}
                                >
                                    Close
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => this.handleSubmitChanges()}
                                    disabled={(!this.state.customSetting['customRange'])}
                                >
                                    Save changes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default SettingsAdmin;


// WEBPACK FOOTER //
// ./src/components/AdminPanel/SettingsAdmin.js